export const chapters = {
    welcome: 'welcome',
    whatsNew: 'whatsNew',
    feedback: 'feedback',
    features: {
        mapAndListView: 'features.mapAndListView',
        mapSearch: 'features.mapSearch',
        assetMarkers: 'features.assetMarkers',
        mapSettings: 'features.mapSettings',
        assetSelection: 'features.assetSelection',
        poiSidebar: 'features.poiSidebar',
        route: 'features.route',
        vehicleSidebar: 'features.vehicleSidebar',
        history: 'features.history',
        positionSharing: 'features.positionSharing',
    },
} as const;

type RecursiveValueOf<T> = T extends string
    ? T
    : T extends Record<string, unknown>
      ? RecursiveValueOf<T[keyof T]>
      : never;

export type ServiceInfoChapter = RecursiveValueOf<typeof chapters>;
